import { render } from "./Drill.vue?vue&type=template&id=65ee7c56&scoped=true"
import script from "./Drill.vue?vue&type=script&lang=js"
export * from "./Drill.vue?vue&type=script&lang=js"

import "./Drill.vue?vue&type=style&index=0&id=65ee7c56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ee7c56"]])

export default __exports__